import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Select,
  Space,
  Table,
  Tag,
  Card,
  Switch,
} from "antd";
import { DeleteOutlined, EditOutlined, HomeOutlined } from "@ant-design/icons";
import { AiFillDelete, AiOutlineMobile } from "react-icons/ai";

import Swal from "sweetalert2";

import { useSelector, useDispatch } from "react-redux";
import { addressActions } from "../../store";

import addressApi from "../../api/addressApi";
import PERMISSION from "../../consts/permissions";
import ghtkApi from "../../api/ghtkApi";
import modulesApi from "../../api/module/modulesApi";

const Address = (props) => {
  const { Option } = Select;

  const dispatch = useDispatch();

  const { lstAddress, totalCount } = useSelector((x) => x.address);
  const { permissions } = useSelector((x) => x.auth);
  const [listPermissions, setPermissions] = useState(permissions);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [form] = Form.useForm();
  const [form2] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [isModalEditContractVisible, setIsModalEditContractVisible] =
    useState(false);

  const [isModalAddress, setIsModalAddress] = useState(false);
  const [addressDefault, setAddressDefault] = useState("");

  const [btnDeleted, setBtnDeleted] = useState(false);
  const [listDeleted, setListDeleted] = useState([]);
  const [titleModal, setTitleModal] = useState("");
  const [isEditModal, setEditModal] = useState(false);
  const [valueForm, setValueForm] = useState({
    id: null,
    name: null,
    phone: null,
    details: null,
    street: null,
    active: null,
    province: null,
    district: null,
    village: null,
    provinceName: null,
    districtName: null,
    villageName: null,
  });

  const [valueForm2, setValueForm2] = useState({
    address: null,
  });

  const [inputFilter, setFilter] = useState({
    // search: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [village, setVillage] = useState();

  useEffect(() => {
    getAddressPaging();
    getStockAddressDefault();
    form.setFieldsValue(valueForm);
  }, [inputFilter, form, valueForm]);

  const getAddressPaging = () => {
    onSelectChange([], []);
    setLoading(true);
    dispatch(addressActions.getShippingAddress(inputFilter)).then(() => {
      setLoading(false);
    });
  };

  const getAddress = (code, type) => {
    const params = {
      parent_id: code,
    };
    ghtkApi.getShipping(params).then((res) => {
      const data = res.data;
      const lstAdd = data.map((item) => {
        return { code: item.id.toString(), name: item.name };
      });

      if (type === "province") {
        setProvince(lstAdd);
        setDistrict([]);
        setVillage([]);
      } else if (type === "district") {
        form.setFieldsValue({
          district: null,
          districtName: null,
          villageName: null,
          village: null,
        });
        setDistrict(lstAdd);
        setVillage([]);
      } else if (type === "village") {
        form.setFieldsValue({
          village: null,
          villageName: null,
        });
        setVillage(lstAdd);
      }
    });
  };

  const getAddressEdit = (code, type) => {
    const params = {
      parent_id: code,
    };
    ghtkApi.getShipping(params).then((res) => {
      const data = res.data;
      const lstAdd = data.map((item) => {
        return { code: item.id.toString(), name: item.name };
      });
      console.log(lstAdd);
      if (type === "province") {
        setProvince(lstAdd);
      } else if (type === "district") {
        setDistrict(lstAdd);
      } else if (type === "village") {
        setVillage(lstAdd);
      }
    });
  };

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      // search: inputFilter.search,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Tên người liên hệ lấy hàng",
      dataIndex: "name",
    },
    {
      title: "Địa chỉ lấy hàng",
      dataIndex: "details",
    },
    {
      title: "Số điện thoại",
      dataIndex: "phone",
    },
    {
      title: "Trạng thái",
      dataIndex: "active",
      render: (active) => (
        <>
          {active === true && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {active === false && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {listPermissions.includes(PERMISSION.Admin_Address_Update) ? (
            <>
              <Button
                onClick={() => showEditModal(record)}
                value="large"
                icon={<EditOutlined />}
              >
                Sửa
              </Button>
            </>
          ) : null}

          {listPermissions.includes(PERMISSION.Admin_Address_Delete) ? (
            <>
              <Button
                value="large"
                type="primary"
                icon={<DeleteOutlined />}
                danger
                onClick={() => deleteAddress(record)}
              >
                Xóa
              </Button>
            </>
          ) : null}
        </Space>
      ),
      width: 150,
      className: "text-center",
      // fixed: "right",
    },
  ];

  const confirm = Modal.confirm;

  const deleteAddress = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa địa chỉ này không?",
      onOk() {
        addressApi
          .deleteAddresss(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getAddressPaging();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteListAddress = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các địa chỉ này không?",
      onOk() {
        addressApi
          .deleteAddresss(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getAddressPaging();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const showEditModal = (record) => {
    getAddressEdit("", "province");
    getAddressEdit(record.province.code, "district");
    getAddressEdit(record.district.code, "village");

    setEditModal(true);
    setTitleModal("Sửa địa chỉ");
    setValueForm({
      id: record.id,
      name: record.name,
      phone: record.phone,
      details: record.details,
      street: record.street,

      province: record.province.code,
      district: record.district.code,
      village: record.village.code,

      provinceName: record.province.name,
      districtName: record.district.name,
      villageName: record.village.name,
      active: record.active,
    });
    setIsModalEditContractVisible(true);
  };

  const showCreateModal = () => {
    getAddress("", "province");
    setTitleModal("Thêm địa chỉ");
    setValueForm({
      id: null,
      name: null,
      phone: null,
      details: null,
      street: null,
      active: null,
      province: null,
      district: null,
      village: null,
      provinceName: null,
      districtName: null,
      villageName: null,
    });
    setEditModal(false);
    setIsModalEditContractVisible(true);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const closePopup = useCallback(() => {
    setValueForm({});
    form.resetFields();
    setIsModalEditContractVisible(false);
  }, [form]);

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateAddress(values);
      } else {
        createAddress(values);
      }
    },
    [isEditModal]
  );

  const createAddress = (data) => {
    const payload = {
      name: data.name,
      details: data.details,
      phone: data.phone,
      street: data.street,
      active: data.active,
      province: {
        name: data.provinceName === null ? "" : data.provinceName,
        code: data.province === null ? "" : data.province,
      },
      district: {
        name: data.districtName === null ? "" : data.districtName,
        code: data.district === null ? "" : data.district,
      },
      village: {
        name: data.villageName === null ? "" : data.villageName,
        code: data.village === null ? "" : data.village,
      },
    };
    addressApi.createAddress(payload).then(
      (res) => {
        // console.log("res", res);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Thêm thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
          getAddressPaging();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateAddress = (data) => {
    const payload = {
      name: data.name,
      details: data.details,
      phone: data.phone,
      street: data.street,
      active: data.active,
      province: {
        name: data.provinceName == null ? "" : data.provinceName,
        code: data.province === null ? "" : data.province,
      },
      district: {
        name: data.districtName == null ? "" : data.districtName,
        code: data.district == null ? "" : data.district,
      },
      village: {
        name: data.villageName == null ? "" : data.villageName,
        code: data.village == null ? "" : data.village,
      },
    };
    addressApi.updateAddress(data.id, payload).then(
      (res) => {
        // console.log("res", res);
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditContractVisible(false);
          getAddressPaging();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  const onChangeSelectProvince = (value, name) => {
    getAddress(value, "district");
    form.setFieldsValue({
      provinceName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectDistrict = (value, name) => {
    getAddress(value, "village");
    form.setFieldsValue({
      districtName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  const onChangeSelectVillage = (value, name) => {
    form.setFieldsValue({
      villageName: name?.children,
    });
    console.log(`selected ${value}`, name?.children);
  };

  useEffect(() => {
    getStockAddressDefault();
  }, []);

  const getStockAddressDefault = () => {
    modulesApi
      .getStockAddressDefault()
      .then((res) => {
        if (res?.values !== null) {
          setValueForm2({
            address: res.values,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const showAddressModal = () => {
    setIsModalAddress(true);
  };

  const closePopup2 = () => {
    setIsModalAddress(false);
  };

  const onFinish2 = (data) => {
    setLoading(true);
    const payload = {
      "stock-address-default": data.address,
    };
    modulesApi
      .createModules(payload)
      .then((res) => {
        if (res) {
          Swal.fire({
            title: "Thành Công!",
            text: "UPdate thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalAddress(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const generatorAddress = () => {
    addressApi
      .generatorAddress()
      .then((res) => {
        console.log(res);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  return (
    <>
      <div className="tabled">
        <br />
        <Space size={10}>
          {listPermissions.includes(PERMISSION.Admin_Address_Create) ? (
            <>
              <Button
                type="dashed"
                size="small"
                onClick={() => showCreateModal()}
              >
                <EditOutlined /> &nbsp; Thêm địa chỉ
              </Button>
            </>
          ) : null}
          <Button
            size="small"
            type="primary"
            onClick={() => showAddressModal()}
          >
            <HomeOutlined /> &nbsp; Địa chỉ mặc định
          </Button>
          <Button size="small" type="dashed" onClick={() => generatorAddress()}>
            &nbsp; Generator Tỉnh/Thành Phố hệ thống
          </Button>
          {listPermissions.includes(PERMISSION.Admin_Address_Delete) ? (
            <>
              {btnDeleted ? (
                <Button
                  value="small"
                  type="primary"
                  icon={<AiFillDelete />}
                  danger
                  onClick={() => {
                    deleteListAddress();
                  }}
                >
                  &nbsp; Xóa các địa chỉ được chọn
                </Button>
              ) : null}
            </>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstAddress}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          title={titleModal}
          visible={isModalEditContractVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
          style={{
            top: 20,
          }}
        >
          <div>
            <Form
              initialValues={valueForm}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="Id" name="id">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tên người liên hệ lấy hàng"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập tên!",
                  },
                ]}
              >
                <Input placeholder="Nhập tên ..." />
              </Form.Item>

              <Form.Item
                label="Địa chỉ lấy hàng	"
                name="details"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập địa chỉ!",
                  },
                ]}
              >
                <Input placeholder="Nhập địa chỉ ..." />
              </Form.Item>

              <Form.Item
                label="Số điện thoại"
                name="phone"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập số điện thoại!",
                  },
                  {
                    pattern: new RegExp(/^[0-9]+$/),
                    message: "Số điện thoại không đúng định dạng!",
                  },
                ]}
              >
                <Input
                  addonAfter={<AiOutlineMobile />}
                  placeholder="Nhập số điện thoại..."
                />
              </Form.Item>

              <Form.Item label="Tên đường" name="street">
                <Input placeholder="Nhập tên đường..." />
              </Form.Item>

              <Form.Item
                label="Tỉnh/Thành Phố"
                name="province"
                rules={[
                  {
                    required: true,
                    message: "Please select province!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  onChange={onChangeSelectProvince}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  {province == null ||
                  province === "undefined" ||
                  province === []
                    ? []
                    : province.map((item, key) => (
                        <Option key={key} value={item.code}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Quận/Huyện"
                name="district"
                rules={[
                  {
                    required: true,
                    message: "Please select district!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  onChange={onChangeSelectDistrict}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  {district == null ||
                  district === "undefined" ||
                  district === []
                    ? []
                    : district.map((item, key) => (
                        <Option key={key} value={item.code}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Phường/Xã"
                name="village"
                rules={[
                  {
                    required: true,
                    message: "Please select village!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  onChange={onChangeSelectVillage}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  {village == null || village === "undefined" || village === []
                    ? []
                    : village.map((item, key) => (
                        <Option key={key} value={item.code}>
                          {item.name}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Trạng thái"
                valuePropName="checked"
                name="active"
              >
                <Switch />
              </Form.Item>
              <Form.Item hidden={true} label="provinceName" name="provinceName">
                <Input />
              </Form.Item>
              <Form.Item hidden={true} label="districtName" name="districtName">
                <Input />
              </Form.Item>
              <Form.Item hidden={true} label="villageName" name="villageName">
                <Input />
              </Form.Item>
            </Form>
          </div>
        </Modal>

        <Modal
          title="Địa chỉ mặc định"
          visible={isModalAddress}
          onOk={form2.submit}
          onCancel={() => {
            closePopup2();
          }}
          style={{
            top: 20,
          }}
        >
          <div>
            <Form
              initialValues={valueForm2}
              form={form2}
              name="basic"
              layout="vertical"
              onFinish={onFinish2}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item
                label="Địa chỉ lấy hàng mặc định"
                tooltip="Địa chỉ này là địa chỉ kho mặc định để tính phí ship từ kho tới địa chỉ của khách khi đặt hàng"
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn ...!",
                  },
                ]}
              >
                <Select
                  showArrow
                  showSearch
                  size="large"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder="Chọn..."
                >
                  {lstAddress == null ||
                  lstAddress === "undefined" ||
                  lstAddress === []
                    ? []
                    : lstAddress.map((item, key) => (
                        <Option key={key} value={item.id}>
                          {item.details}
                        </Option>
                      ))}
                </Select>
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Address;
